import type { Sequence } from "../types/Sequence"

export function All<T>(
  iterable: Sequence<T>,
  func: (item: T) => boolean = a => (a ? true : false)
) {
  for (const t of iterable) {
    if (!func(t)) return false
  }
  return true
}
